/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonCompanyBranch
 */
export interface JsonCompanyBranch {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonCompanyBranch
     */
    allowedActions?: Array<JsonCompanyBranchAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonCompanyBranch
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyBranch
     */
    companyBranchId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyBranch
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonCompanyBranch
     */
    status?: JsonCompanyBranchStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonCompanyBranch
     */
    title?: string;
}

/**
* @export
* @enum {string}
*/
export enum JsonCompanyBranchAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonCompanyBranchStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonCompanyBranchFromJSON(json: any): JsonCompanyBranch {
    return JsonCompanyBranchFromJSONTyped(json, false);
}

export function JsonCompanyBranchFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonCompanyBranch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'companyBranchId': !exists(json, 'companyBranchId') ? undefined : json['companyBranchId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function JsonCompanyBranchToJSON(value?: JsonCompanyBranch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'companyBranchId': value.companyBranchId,
        'companyId': value.companyId,
        'status': value.status,
        'title': value.title,
    };
}

